import React, { PropsWithChildren } from 'react';
import { Container, FlexContainer, Grid, GridItem } from '..';

export interface SingleColumnLayoutProps {
    headerContent: React.ReactNode | React.ReactNodeArray;
}

export interface NavLayoutProps {
    nav: React.ReactNode | React.ReactNodeArray;
}

export function SingleColumnLayout({
    headerContent,
    children,
}: PropsWithChildren<SingleColumnLayoutProps>): JSX.Element {
    return (
        <FlexContainer
            sx={{ margin: '0 auto' }}
            stack={['96px', null, '48px']}
            height="100%"
            maxWidth="968px"
            direction="column"
            gap="32px"
        >
            <Container height={['64px', null, '240px']}>{headerContent}</Container>
            <Container as="main" height="100%">
                {children}
            </Container>
        </FlexContainer>
    );
}

/* This is probably good to go as is */
export function NavLayout({ nav, children }: PropsWithChildren<NavLayoutProps>): JSX.Element {
    return (
        <Grid
            gap="none"
            height="100vh"
            templateRows={['80px 1fr', null, '1fr']}
            templateColumns={['1fr', null, '200px 1fr', '256px 1fr']}
        >
            <GridItem as="nav" colStart={1} colSpan={1} rowStart={1}>
                {nav}
            </GridItem>
            <GridItem as="main">{children}</GridItem>
        </Grid>
    );
}
